import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';

const KeyboardShortcutsBar = ({ colorTheme, vendorItemsCount, currentVendorItemIndex, isNonVariantMode }) => {
  const isDark = colorTheme === 'dark';

  const shortcuts = [
    { key: 'F1', label: 'Current Week' },
    { key: 'F2', label: 'Forward 4 Weeks' },
    { key: 'F3', label: 'Back 4 Weeks' },
    { key: 'F4', label: isNonVariantMode ? 'Prev WPID' : 'Prev Item' },
    { key: 'F5', label: isNonVariantMode ? 'Next WPID' : 'Next Item' },
    ...(!isNonVariantMode ? [
      { key: 'F7', label: 'Prev Vendor Item' },
      { key: 'F8', label: 'Next Vendor Item' }
    ] : [])
  ];

  const shortcutText = shortcuts
    .map(s => `${s.key} - ${s.label}`)
    .join(' | ');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: isDark ? '#1A1A1A' : '#F7F9FC',
        padding: '0 12px',
        fontSize: '13px',
        borderTop: isDark ? '1px solid #2A2A2A' : '1px solid #D1DAE5',
        position: 'fixed',
        bottom: '43px',
        left: 0,
        right: 0,
        height: '40px',
        boxShadow: isDark
          ? '0 -1px 3px rgba(0, 0, 0, 0.3)'
          : '0 -1px 3px rgba(0, 23, 47, 0.06)',
        zIndex: 998,
        transition: 'all 0.2s ease'
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '13px',
          fontWeight: 400,
          color: isDark ? '#A0A0A0' : '#516069',
          letterSpacing: '0.2px',
          userSelect: 'none'
        }}
      >
        {shortcutText}
      </Typography>

      {vendorItemsCount > 0 && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: isDark ? '#3A3A3A' : '#D1DAE5',
              margin: '0 16px'
            }}
          />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: 0,
              borderRadius: 0,
              border: 'none',
              backgroundColor: 'transparent',
              boxShadow: 'none'
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: '11px',
                fontWeight: 500,
                color: isDark ? '#A0A0A0' : '#516069',
                letterSpacing: '0.3px',
                userSelect: 'none'
              }}
            >
              Vendor Item
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: '12px',
                fontWeight: 600,
                color: isDark ? '#A0A0A0' : '#516069',
                userSelect: 'none'
              }}
            >
              {currentVendorItemIndex + 1} / {vendorItemsCount}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

KeyboardShortcutsBar.propTypes = {
  colorTheme: PropTypes.string,
  vendorItemsCount: PropTypes.number,
  currentVendorItemIndex: PropTypes.number,
  isNonVariantMode: PropTypes.bool
};

export default KeyboardShortcutsBar;
